

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
      align:'center'
    },
    {
      key: 'workunit',
      dataIndex: 'workunit',
      title: '单位',
      align:'center'
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '用户id',
      align:'center'
    },
    {
      key: 'realname',
      dataIndex: 'realname',
      title: '姓名',
      align:'center'
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '手机号',
      align:'center'
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '编辑',

      width: 100,
      slot: 'operate1',
      align:'center'
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '删除',

      width: 100,
      slot: 'operate',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
